import { Identity } from '@sdbn/appclient';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { Transport } from '../model/Transport';
import { environment } from 'src/environments/environment';
import { EntranceRegistration } from '../model/out/entrance-registration';
import { map } from 'rxjs/operators';
import { AreaGate } from '../model/areaGate';

@Injectable({
  providedIn: 'root'
})
export class RegisterEntranceService {
  
  getAreaGates() {
    return this.http.postWithContext<AreaGate[]>(`${environment.registerEntranceEndpoint}/area-gates`, {}).pipe(map(response => {
      const gates = new Array<AreaGate>();
      for (const entry of response) {
        gates.push(new AreaGate(entry));
      }
      return gates;
    }));
  }

  constructor(private http: HttpService) { }

  getTransport(identity: Identity): Observable<Transport> {
    return this.http.postWithContext<Transport>(`${environment.registerEntranceEndpoint}/transport`, identity);
  }

  accept(identity: EntranceRegistration): Observable<any> {
    return this.http.postWithContext<any>(`${environment.registerEntranceEndpoint}/accept`, identity);
  }

  decline(identity: EntranceRegistration) {
    return this.http.postWithContext<any>(`${environment.registerEntranceEndpoint}/decline`, identity);
  }
}
